var React = require('react');

function PhoneWhite (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"phonewhite_Path_371","data-name":"phonewhite_Path 371","d":"M54.076,55.918c-.517-.411-1.064-.778-1.6-1.155-1.079-.751-2.068-.809-2.868.4a1.256,1.256,0,0,1-1.746.411A7.711,7.711,0,0,1,43.8,51.652a1.5,1.5,0,0,1,.495-2.118,1.5,1.5,0,0,0,.87-1.329,8.993,8.993,0,0,0-3.006-4.069,1.533,1.533,0,0,0-1.045,0,2.917,2.917,0,0,0-2,4.155A21.632,21.632,0,0,0,51.163,60.3a5.7,5.7,0,0,0,.862.241,3.908,3.908,0,0,0,3.216-2.429c.417-1.17-.464-1.635-1.162-2.193Z","transform":"matrix(0.995, -0.105, 0.105, 0.995, -43.219, -38.017)","fill":"#fff"}));
}

PhoneWhite.defaultProps = {"width":"18.155","height":"18.132","viewBox":"0 0 18.155 18.132"};

module.exports = PhoneWhite;

PhoneWhite.default = PhoneWhite;
